import { render, staticRenderFns } from "./MypageDiscountPayment.vue?vue&type=template&id=5136fa1d&"
import script from "./MypageDiscountPayment.vue?vue&type=script&lang=js&"
export * from "./MypageDiscountPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports